import React, {useContext} from 'react'
import {useLocation, useNavigate} from "react-router";
import {AppContext} from "../../context/app-context";
import {requestLogBackInAsAdmin} from "./request/adminRequests";
import {toast} from "react-toastify";
import {hasAdminAccess, isAdminAccount} from "../../util/AccountUtils";
import {Account} from "../../interfaces";

const LoggedInAsHeader = () => {
  const appContext = useContext(AppContext)
  const {user, updateUser} = appContext
  const {companyName} = user || {}
  const location = useLocation()

  const history = useNavigate()

  const handleBackToAdmin = () => {
    requestLogBackInAsAdmin()?.then((resp: { body: Account; }) => updateUser(resp.body, history))
      .catch(handleError)
  }

  return hasAdminAccess(user) && !isAdminAccount(user) &&
    <div className={location.pathname === '/about' ? `logged-in-as-info w-100 ss-z-index` : `logged-in-as-info w-100`}>
      <span className="logged-in-as-label">LOGGED IN AS:</span>
      {companyName}
      <button className="ss-button-secondary" onClick={handleBackToAdmin}>
        Back To Admin Account
      </button>
    </div>
}

const handleError = (err: { message: any; }) => {
  const message = (err && err.message) ? err.message : 'Internal Server Error'
  toast.error(message)
}

export default LoggedInAsHeader
